'use client';

import { useLayoutEffect } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import { useAuth } from '@/components/auth/auth-context';

const ALLOWED_PREFIXES = ['/crm', '/signin', '/signup', '/auth', '/reset-password'];

function isAllowedPath(pathname: string) {
  if (!pathname) return true;
  // убираем locale-prefix: /en-US/crm → /crm
  const stripped = pathname.replace(/^\/[a-z]{2}(-[A-Z]{2})?(?=\/|$)/, '') || '/';
  return ALLOWED_PREFIXES.some((p) => stripped === p || stripped.startsWith(p + '/'));
}

export function SalesmanRedirect() {
  const { user, isLoading } = useAuth();
  const router   = useRouter();
  const pathname = usePathname();

  useLayoutEffect(() => {
    if (isLoading || !user) return;
    if (user.role !== 'SALESMAN') return;
    if (!isAllowedPath(pathname)) {
      router.replace('/crm');
    }
  }, [user, isLoading, pathname, router]);

  return null;
}